export const SSE_CONNECT = "SSE_CONNECT";
export const SSE_DISCONNECTED = "SSE_DISCONNECTED";
export const SSE_GET_PRODUCTS_BULK_OPERATION_FINISH = "SSE_GET_PRODUCTS_BULK_OPERATION_FINISH";
export const SSE_GET_PRODUCTS_BULK_OPERATION_FAILED = "SSE_GET_PRODUCTS_BULK_OPERATION_FAILED";
export const SSE_PRODUCT_MESSAGE = "SSE_PRODUCT_MESSAGE";

export const SSE_REQUEST_STATUS_PENDING = "SSE_REQUEST_STATUS_PENDING";
export const SSE_REQUEST_STATUS_SUCCESS = "SSE_REQUEST_STATUS_SUCCESS";
export const SSE_REQUEST_STATUS_FAILED = "SSE_REQUEST_STATUS_FAILED";